import z from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'
import { PromptVersionStatus } from './types'

/**
 * path: prompt/{promptType}/type/{type}/prompt_version/{versionId}
 */
const baseSchema = z.object({
  primaryPrompt: z.string(),
  versionName: z.string(),
  versionNotes: nullSafeOptionalString(),
  versionStatus: z.nativeEnum(PromptVersionStatus),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  creatorUserId: nullSafeOptionalString(),
  confidenceThreshold: z.number().int().min(0).max(100).optional(),
  publisherUserId: nullSafeOptionalString(),
  publisherNotes: nullSafeOptionalString(),
  publishedDate: nullSafeOptionalFirestoreTimestamp(),
})

// no other fields at the moment, no extension necessary
export const interactiveElementPromptVersionSchema = baseSchema

export const rubricPromptVersionSchema = baseSchema.extend({
  outputPrompt: z.string(), // required for rubric
  statsPrompt: z.string(), // required for rubric
  reminderPrompt: z.string(), //required for rubric
})

export const postRoomStatePromptVersionSchema = baseSchema.extend({
  outputPrompt: z.string(), // required for post room state
  reminderPrompt: nullSafeOptionalString(), //optional for post room state
})

export const emptyRubricPromptVersion = Object.freeze(
  rubricPromptVersionSchema.parse({
    primaryPrompt: '',
    versionName: '',
    versionNotes: '',
    versionStatus: PromptVersionStatus.draft,
    outputPrompt: '',
    statsPrompt: '',
    reminderPrompt: '',
  })
)

export const emptyInteractiveElementPromptVersion = Object.freeze(
  interactiveElementPromptVersionSchema.parse({
    primaryPrompt: '',
    versionName: '',
    versionNotes: '',
    versionStatus: PromptVersionStatus.draft,
  })
)

export const emptyPostRoomStatePromptVersion = Object.freeze(
  postRoomStatePromptVersionSchema.parse({
    primaryPrompt: '',
    versionName: '',
    versionNotes: '',
    versionStatus: PromptVersionStatus.draft,
    outputPrompt: '',
  })
)

export type FirestoreRubricPromptVersion = z.infer<
  typeof rubricPromptVersionSchema
>
export type FirestoreInteractiveElementPromptVersion = z.infer<
  typeof interactiveElementPromptVersionSchema
>
export type FirestorePostRoomStatePromptVersion = z.infer<
  typeof postRoomStatePromptVersionSchema
>
